<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      tableData: [],
      title: "大会情報",
      items: [
        {
          text: "GameInfo",
          href: "/",
        },
        {
          text: "大会情報",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      game_id: "",
      event_id: "",
      division: "",
      block: "",
      price_mode: 0,
      price: '',
      fix: false,
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: [
        "game_name",
        "start_date",
        "end_date",
        "event_name",
        "division",
        "block",
        "price_label"
      ], // 一覧に表示されている項目のみフィルタ対象にする
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "game_name",
          label: "大会名",
          sortable: true,
          tdClass: "minWidth200",
        },
        {
          key: "start_date",
          label: "開始日", // 開始日を追加
          sortable: true,
          tdClass: "minWidth120",
        },
        {
          key: "end_date",
          label: "終了日", // 終了日を追加
          sortable: true,
          tdClass: "minWidth120",
        },
        {
          key: "event_name",
          label: "種目名",
          sortable: true,
          tdClass: "minWidth200",
        },
        {
          key: "division",
          label: "枠数",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "block",
          label: "ブロック数",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "price_label",
          label: "料金",
          sortable: false,
          tdClass: "minWidth100",
        },
        {
          key: "fix",
          label: "確定",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "status",
          label: "エントリー",
          sortable: true,
          tdClass: "minWidth100",
        }, // 追加
        { key: "actions", label: "", sortable: false, tdClass: "minWidth400" },
      ],
      loading: false,
      mode: "list",
      games: [], // ゲーム一覧を格納
      events: [], // イベント一覧を格納
      notices: [],
      modalNotice: null, // モーダルで表示するお知らせ
      search_game_id: "", // 大会検索用
      gameList: [{ value: "", text: "すべて" }], // プルダウン用
    };
  },
  mounted() {
    let roles = this.$store.getters.roles;
    if (roles == "admin") {
      this.getUser("admin");
    } else if (roles == "user") {
      this.getUser("user");
      this.search_school_code = this.$store.getters.schoolCode;
    } else {
      window.location.href = "/";
      return;
    }
    this.searchItems();
  },
  computed: {
    rows() {
      return this.filterItems.length;
    },
    // 一覧のカラムを権限で動的に切り替え
    displayFields() {
      // userの場合は枠数・ブロック数・確定・チェックボックスを除外
      if (this.$store.getters.roles === "user") {
        return this.fields.filter(
          f => !["division", "block", "price_label", "checkbox"].includes(f.key)
        );
      }
      if (this.$store.getters.roles === "admin") {
        return this.fields.filter(
          f => !["status"].includes(f.key)
        );
      }
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      // パラメータにgame_idを追加
      let params = {};
      if (this.search_game_id) {
        params.game_id = this.search_game_id;
      }
      axios
        .get("/api/game-info", { params })
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          this.tableData = response.data.gameInfos.map((item) => {
            return {
              ...item,
              fix: item.fix === 1,
              status: item.entry_status === 1, // statusをbooleanに変換
              price_label: item.price_label
            };
          });
          console.log(this.tableData);
          // 大会リストをセット
          this.gameList = [{ value: "", text: "" }]
            .concat(response.data.games.map(game => ({
              value: game.id,
              text: game.name
            })));
          this.events = response.data.events || [];
          this.notices = response.data.notices || [];
          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/game-info/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.game_id = "";
      this.event_id = "";
      this.division = "";
      this.block = "";
      this.fix = false;
      this.price_mode = 0;
      this.price = '';
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.game_id = item.game_id;
      this.event_id = item.event_id;
      this.division = item.division;
      this.block = item.block;
      this.fix = item.fix;
      // price_mode が 0 または 1 でなければ 0 を設定（空文字等の防止）
      if (item.price_mode === 0 || item.price_mode === 1) {
        this.price_mode = item.price_mode;
      } else {
        this.price_mode = 0;
      }
      this.price = typeof item.price !== 'undefined' ? item.price : '';
    },
    // フラグ更新
    updateFlg(item) {
      // ログ出力で値を確認
      console.log('updateFlg item:', item);
      this.id = item.id;
      this.game_id = item.game_id;
      this.event_id = item.event_id;
      this.division = item.division;
      this.block = item.block;
      this.fix = item.fix ?? false; // nullやundefinedの場合はfalseを設定
      this.price_mode = item.price_mode ?? 0; // nullやundefinedの場合は0を設定
      this.price = item.price ?? ''; // nullやundefinedの場合は空文字を設定
      // 送信前に現在の値も確認
      console.log('updateFlg form:', {
        id: this.id,
        game_id: this.game_id,
        event_id: this.event_id,
        division: this.division,
        block: this.block,
        fix: this.fix,
        price_mode: this.price_mode,
        price: this.price
      });
      this.submit();
    },
    // status更新
    updateStatus(item) {
      let formData = new FormData();
      formData.append("game_info_id", item.id);
      formData.append("status", item.status ? 1 : 0);
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .post("/api/game-info/update-status", formData, config)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 確定
    submit() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("game_id", this.game_id);
      formData.append("event_id", this.event_id);
      formData.append("division", this.division);
      formData.append("block", this.block);
      formData.append("fix", this.fix ? 1 : 0);
      formData.append("price_mode", this.price_mode);
      formData.append("price", this.price ?? '');
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .post("/api/game-info/update", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
    formatDate(date) {
      if (!date) return ""; // nullまたはundefinedの場合は空欄を返す
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date).toLocaleDateString("ja-JP", options);
    },
    goToEntry(item) {
      this.$store.commit("setGameInfoId", item.id);
      window.location.href = `/entry`;
    },
    goToTournament(item) {
      this.$store.commit("setGameInfoId", item.id);
      window.location.href = `/tournament`;
    },
    goToStaff(item) {
      this.$store.commit("setGameId", item.game_id);
      window.location.href = `/staff`;
    },
    openNoticeModal(notice) {
      // APIでnotice_idを送信してnotice_showsに追加
      axios.post('/api/game-info/show-notice', { notice_id: notice.id })
        .then(() => {
          // show_flagを0→1に変更（Newバッジを消す）
          console.log("notice_id:", notice.id);
          notice.show_flag = 1;
        })
        .catch(() => {
          // エラー時もモーダルは開く
        })
        .finally(() => {
          this.modalNotice = notice;
          this.$nextTick(() => {
            this.$bvModal.show('notice-modal');
          });
        });
    },
    formatNoticeDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const yyyy = d.getFullYear();
      const mm = ("0" + (d.getMonth() + 1)).slice(-2);
      const dd = ("0" + d.getDate()).slice(-2);
      return `${yyyy}/${mm}/${dd}`;
    },
    formatNoticeTime(time) {
      // "HH:MM:SS" → "HH:MM" に変換
      if (!time) return "";
      return time.slice(0, 5);
    },
    exportEntrySheetUser() {
      if (!this.search_game_id) {
        this.$toasted.error("大会を選択してください");
        return;
      }
      this.loading = true;
      axios
        .get("/api/game-info/export/entry-sheet", {
          params: {
            game_id: this.search_game_id,
          },
          responseType: "blob", // PDFバイナリデータを取得
        })
        .then((response) => {
          this.loading = false;
          // Content-Dispositionヘッダからファイル名を取得
          let fileName = "entrysheet.pdf";
          const disposition = response.headers['content-disposition'];
          if (disposition && disposition.indexOf('filename=') !== -1) {
            fileName = decodeURIComponent(disposition.split('filename=')[1].replace(/['"]/g, ''));
          }
          const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
          this.errorProcess(error);
        });
    },
    exportEntrySheetAdmin() {
      if (!this.search_game_id) {
        this.$toasted.error("大会を選択してください");
        return;
      }
      // 選択中の大会名を取得
      let gameName = "";
      const selectedGame = this.gameList.find(
        g => String(g.value) === String(this.search_game_id)
      );
      if (selectedGame && selectedGame.text) {
        gameName = selectedGame.text;
      }
      this.loading = true;
      axios
        .get("/api/entry/export/list", {
          params: {
            game_id: this.search_game_id,
          },
          responseType: "blob",
        })
        .then((response) => {
           this.loading = false;
         // ファイル名を大会名＋エントリーリスト.xlsxにする
          let fileName = gameName + "_エントリーリスト.xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    exportCheckAdmin() {
      if (!this.search_game_id) {
        this.$toasted.error("大会を選択してください");
        return;
      }
      // 選択中の大会名を取得
      let gameName = "";
      const selectedGame = this.gameList.find(
        g => String(g.value) === String(this.search_game_id)
      );
      if (selectedGame && selectedGame.text) {
        gameName = selectedGame.text;
      }
      this.loading = true;
      axios
        .get("/api/entry/export/check", {
          params: {
            game_id: this.search_game_id,
          },
          responseType: "blob",
        })
        .then((response) => {
          this.loading = false;
          // ファイル名を大会名＋エントリーチェックシート.xlsxにする
          let fileName = gameName + "_エントリーチェックシート.xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>

<style>
.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth120 {
  min-width: 120px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth400 {
  min-width: 400px;
  word-break: break-all;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- お知らせ一覧 -->
    <div class="mb-4">
      <div class="card">
        <div class="card-body p-3">
          <div class="row">
            <div class="ms-1 mb-0 pb-0">
              <strong>お知らせ</strong>
            </div>
          </div>
          <hr class="mt-1 pt-0" />
          <!-- ul→divに変更し、li→divでドットを消す -->
          <div class="mb-0 ms-3">
            <div v-for="notice in notices" :key="notice.id" class="mb-2">
              <span class="fw-bold" style="cursor: pointer;" @click="openNoticeModal(notice)">
                {{ notice.title }}
              </span>
              <!-- show_flagが0ならNewバッジを表示 -->
              <span v-if="notice.show_flag === 0" class="badge bg-danger ms-2">New</span>
              <span class="text-muted ms-2" style="font-size: 0.9em;">
                {{ formatNoticeDate(notice.create_date) }} {{ formatNoticeTime(notice.create_time) }}
              </span>
            </div>
            <div v-if="notices.length === 0" class="text-muted">お知らせはありません。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-12 col-md-4">
                <b-form-group label="大会" label-cols-sm="3">
                  <b-form-select v-model="search_game_id" :options="gameList" @change="searchItems"
                    class="form-select"></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="displayFields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(start_date)="{ item }">
                  {{ formatDate(item.start_date) }}
                </template>
                <template v-slot:cell(end_date)="{ item }">
                  {{ formatDate(item.end_date) }}
                </template>
                <template v-slot:cell(fix)="{ item }">
                  <!-- 管理者のみ変更可能にする -->
                  <div v-if="$store.getters.roles === 'admin'">
                    <b-form-checkbox plain v-model="item.fix" @change="updateFlg(item)"></b-form-checkbox>
                  </div>
                  <div v-else>
                    <!-- user は表示のみ（変更不可） -->
                    <b-form-checkbox plain v-model="item.fix" disabled></b-form-checkbox>
                  </div>
                </template>
                <template v-slot:cell(status)="{ item }">
                  <b-form-checkbox plain v-model="item.status" @change="updateStatus(item)" :disabled="item.fix">
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span>
                    <!-- adminのみ編集ボタンを表示 -->
                    <button v-if="$store.getters.roles === 'admin'" class="btn btn-sm btn-outline-primary me-2"
                      @click="edit(item)">
                      編集
                    </button>
                    <button v-if="$store.getters.roles === 'admin'" class="btn btn-sm btn-outline-info me-2"
                      @click="goToTournament(item)">
                      トーナメント
                    </button>
                    <button class="btn btn-sm btn-outline-info me-2" @click="goToEntry(item)">
                      Entry
                    </button>
                    <button class="btn btn-sm btn-outline-info me-2" @click="goToStaff(item)">
                      顧問・コーチ
                    </button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete
                    v-if="$store.getters.roles === 'admin'">
                    削除
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="add"
                    v-if="$store.getters.roles === 'admin'">
                    追加
                  </button>
                  <button class="btn btn-success" type="button" @click="exportEntrySheetUser"
                    v-if="$store.getters.roles === 'user'">
                    シート出力
                  </button>
                  <button class="btn btn-success me-2" v-if="$store.getters.roles === 'admin'"
                    @click="exportEntrySheetAdmin">リスト出力</button>
                  <button class="btn btn-success me-2" v-if="$store.getters.roles === 'admin'"
                    @click="exportCheckAdmin">チェックシート出力</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group label="ゲーム" label-cols-sm="3">
                      <ValidationProvider name="ゲーム" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select plain v-model="game_id" :options="gameList"
                            style="width: 200px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="イベント" label-cols-sm="3">
                      <ValidationProvider name="イベント" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select plain v-model="event_id"
                            :options="events.map(event => ({ value: event.id, text: event.name }))"
                            style="width: 200px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="枠数" label-cols-sm="3">
                      <ValidationProvider name="枠数"
                        :rules="{ required: true, numeric: true, min_value: 1, max_value: 99 }" v-slot="ProviderProps">
                        <b-form-input type="number" style="width: 100px" v-model="division" autocomplete="off" min="1"
                          max="99"></b-form-input>
                        <p class="text-danger mb-2">
                          {{ ProviderProps.errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="ブロック数" label-cols-sm="3">
                      <ValidationProvider name="ブロック数"
                        :rules="{ required: true, numeric: true, min_value: 1, max_value: 99 }" v-slot="ProviderProps">
                        <b-form-input type="number" style="width: 100px" v-model="block" autocomplete="off" min="1"
                          max="99"></b-form-input>
                        <p class="text-danger mb-2">
                          {{ ProviderProps.errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="料金" label-cols-sm="3">
                      <div class="d-flex align-items-center">
                        <ValidationProvider name="料金種別" :rules="{ required: true }" v-slot="pm">
                          <div>
                            <b-form-select v-model="price_mode" plain :options="[
                              { value: 0, text: '人数' },
                              { value: 1, text: '固定' }
                            ]" style="width: 120px"></b-form-select>
                            <div class="text-danger">{{ pm.errors[0] }}</div>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider :rules="{ numeric: true }" name="金額" v-slot="pv">
                          <div style="margin-left: 12px;">
                            <b-form-input v-model.number="price" type="number" step="1" min="0" placeholder="金額"
                              style="width: 140px;"></b-form-input>
                            <div class="text-danger">{{ pv.errors[0] }}</div>
                          </div>
                        </ValidationProvider>
                      </div>
                    </b-form-group>
                    <b-form-group label="確定" label-cols-sm="3">
                      <ValidationProvider name="確定" :rules="{
                        required: false,
                      }">
                        <div slot-scope="ProviderProps" class="mt-2">
                          <b-form-checkbox plain v-model="fix">
                            確定
                          </b-form-checkbox>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <!-- お知らせモーダル -->
    <b-modal id="notice-modal" v-if="modalNotice" :title="modalNotice.title" @hide="modalNotice = null" ok-only>
      <div class="pb-2">
        <div class="mb-2 text-muted" style="font-size: 1.0em;">
          {{ formatNoticeDate(modalNotice.create_date) }} {{ formatNoticeTime(modalNotice.create_time) }}
        </div>
        <div style="font-size: 1.1em; white-space: pre-line;">
          {{ modalNotice.detail }}
        </div>
      </div>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
